module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("The author would like to thank Dr. Jeffrey Scott Nye, neurobiologist, and Dr. Elizabeth Nye, OB-GYN, for their research and input, and acknowledge that any errors made in the use of their data are her own. The author sincerely thanks Beth Fleisher for lending her countenance to this project. She is also grateful to Sue Stone for her experience, and to Peter Heck and Laura Anne Gilman for patience and advice and more patience.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 72
// module chunks = 0